import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { CampaignFacadeService } from '@uw/core/facades/campaign.facade.service';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { Observable, of, filter, first, mergeMap, take, tap, timeout } from 'rxjs';
import { UserFacadeService } from '../facades/user.facade.service';

@Injectable()
export class DonorCampaignsListResolver  {

  constructor(protected campaignService: CampaignService,
    protected campaignStateService: CampaignStateService,
    protected userFacadeService: UserFacadeService,
    protected campaignFacadeService: CampaignFacadeService,
    protected router: Router) {
  }

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot,): Observable<boolean> {
    return this.userFacadeService.getAuthUser()
    .pipe(
      take(1),
      mergeMap(user=> {
        if (user && user.token) {
          return this.loadDonorList();
        } else {
          return of(true);
        }
      })
    );
  }

  loadDonorList(){
    return this.campaignFacadeService.isDonorCampaignListLoaded.pipe(
      tap(loaded => {
        if (!loaded){
          this.campaignFacadeService.loadDonorCampaignList();
        }
      }),
      filter(loaded => loaded),
      first(),
      // If campaign list fails to load (reducer sets loaded:false on failure),
      // filter never emits and Angular cancels navigation. Allow navigation after
      // 10s so pages under /info/* (privacy policy, help desk) are always reachable.
      timeout({ first: 10_000, with: () => of(true) })
    );
  }

}
